export default "__VITE_ASSET__039b1d8c__"